/**
 * Gets hostname without 'www.' at the beginning
 *
 * @returns {string}
 */
const getHost = () => {
  return window.location.hostname.replace('www.', '');
};

export const currentHost = getHost();
